import * as React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { CUT_OUT_TYPES } from 'franke-trough-dependencies';
import { includes as _includes } from 'lodash';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './Recesses.messages';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';

export interface CutOutDisposalSelectionProps {
  options: CUT_OUT_TYPES[];
  selected: null | CUT_OUT_TYPES;
  enabled: CUT_OUT_TYPES[];
  onSelect?: (selected: (CUT_OUT_TYPES | null)) => void;
  configuration: GlobalPrivateState['configuration'];
}

export interface CutOutDisposalSelectionState {
  dropdownOpen: boolean;
  selected: null | CUT_OUT_TYPES;
}

export const CutOutLabel: React.SFC<{value: CUT_OUT_TYPES | null, text?: boolean}> = (props) => {
  switch (props.value) {
    case 'CUSTOM_ROUND':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelCustomRound} />
        </span>
      );
    case 'CUSTOM_SQUARE':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelCustomSquare} />
        </span>
      );
    case 'ROUND_SLEEVE':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelRoundSleeve} />
        </span>
      );
    case 'SQUARE_SLEEVE':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelSquareSleeve} />
        </span>
      );
    case 'ROUND_BASKET':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelRoundBasket} />
        </span>
      );
    case 'ROUND_RAIL':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelRoundRail} />
        </span>
      );
    case 'SQUARE_BASKET':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelSquareBasket} />
        </span>
      );
    case 'SQUARE_RAIL':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelSquareRail} />
        </span>
      );
    case 'ROUND_SLEEVE_BASKET':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelRoundSleeveBasket} />
        </span>
      );
    case 'ROUND_SLEEVE_RAIL':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelRoundSleeveRail} />
        </span>
      );
    case 'SQUARE_SLEEVE_BASKET':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelSquareSleeveBasket} />
        </span>
      );
    case 'SQUARE_SLEEVE_RAIL':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelSquareSleeveRail} />
        </span>
      );
    case 'FLAP':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelFlap} />
        </span>
      );
    case 'FLAP_BASKET':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelFlapBasket} />
        </span>
      );
    case 'FLAP_RAIL':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelFlapRail} />
        </span>
      );
    case 'PROVIDER':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelProvider} />
        </span>
      );
    case 'COSMETIC':
      return (
        <span>
          <FormattedMessage {...MESSAGES.cutOutLabelCosmetic} />
        </span>
      );
    case null: 
      return (
        <span><FormattedMessage {...MESSAGES.cutOutLabelSelect} /></span>
      );
    default:
      return null;
  } 
};

export class CutOutDisposalSelectionPartial extends React.Component<CutOutDisposalSelectionProps, CutOutDisposalSelectionState> {
  constructor(props: CutOutDisposalSelectionProps) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      selected: props.selected,
    };
    this.handleClick = this.handleClick.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentDidUpdate() {
    if (this.props.selected !== this.state.selected) {
      this.setState({
        ...this.state,
        selected: this.props.selected,
      });
    }
  }

  public render() {
    const {
      options,
      enabled,
      configuration
    } = this.props;

    const selected = this.state.selected || this.props.selected || null;
    const configurationId = configuration.result && configuration.result.id;
    
    return (
      <div className="partial-cutout-selection">
        <Dropdown
          className="dropdown-select"
          isOpen={this.state.dropdownOpen} 
          toggle={this.toggle}
        >
          <DropdownToggle 
            caret={true} 
          >
            <CutOutLabel value={selected} />
            {selected && (
              <img src={'/img/cut-outs/thumbnails/'+selected+'.jpg'} alt="Placeholder" width={30} height={30} className="img-fluid" />
            )}
          </DropdownToggle>
          <DropdownMenu>
            {options && options.map((value, index) => {
              const key = `cut_out_key_${index}`;

              return (
                <DropdownItem 
                  key={key} 
                  onClick={() => this.handleClick(value)}
                  disabled={!_includes(enabled, value)}
                  className={selected === value ? 'active' : ''}
                >
                  <CutOutLabel value={value} text={true} />
                  <img src={'/img/cut-outs/thumbnails/'+value+'.jpg'} alt="Placeholder" width={30} height={30} className="img-fluid" />
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </Dropdown>
        <div className="info-icon-plain btn">
          {selected && (
            <Link to={`/configuration/${configurationId}/recesses/${selected}`}>
              <FontAwesomeIcon icon={faInfo} />
            </Link>
          )}
        </div>
      </div>
    );
  }

  private handleClick(value: (CUT_OUT_TYPES | null)): void {
    if (this.props.onSelect) {
      this.props.onSelect(value);
    }

    setTimeout(() => {
      this.setState({
        selected: value,
        dropdownOpen: false, // True, because toggle is triggered directly after...
      });
    }, 1);
  }

  private toggle() {
    this.setState(prevState => ({
      ...this.state,
      dropdownOpen: !prevState.dropdownOpen
    }));
  }
}

export const CutOutDisposalSelection = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(CutOutDisposalSelectionPartial);

export default CutOutDisposalSelection;
